import React from 'react';
const ITEMS = [
  { id: 1, name: 'Ribeye Steak 12oz', type: 'Beef', price: '$18.99/lb', temp: '34F', onHand: 24, grind: false, status: 'Fresh' },
  { id: 2, name: 'Ground Beef 80/20', type: 'Beef', price: '$7.99/lb', temp: '35F', onHand: 35, grind: true, status: 'Fresh' },
  { id: 3, name: 'Chicken Breast', type: 'Poultry', price: '$6.99/lb', temp: '33F', onHand: 48, grind: false, status: 'Fresh' },
  { id: 4, name: 'Atlantic Salmon', type: 'Seafood', price: '$12.99/lb', temp: '31F', onHand: 18, grind: false, status: 'Sell Today' },
  { id: 5, name: 'Shrimp 16/20 ct', type: 'Seafood', price: '$14.99/lb', temp: '30F', onHand: 12, grind: false, status: 'Fresh' },
  { id: 6, name: 'Pork Tenderloin', type: 'Pork', price: '$8.99/lb', temp: '34F', onHand: 20, grind: false, status: 'Fresh' },
];
const SC = { Fresh: '#16A34A', 'Sell Today': '#F59E0B', Expired: '#EF4444' };
export default function MeatSeafoodPage() {
  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Meat & Seafood</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>Fresh cuts, temperature logs, and grind tracking</p>
      </div>
      <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>{['Item', 'Type', 'Price', 'Temp', 'On Hand', 'Ground', 'Status'].map(h => (
            <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--text-muted)', borderBottom: '1px solid var(--border)', background: 'rgba(15,23,42,0.3)' }}>{h}</th>
          ))}</tr></thead>
          <tbody>{ITEMS.map(item => (
            <tr key={item.id} style={{ borderBottom: '1px solid var(--border)' }}>
              <td style={{ padding: '12px 16px', color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{item.name}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text-secondary)', fontSize: 13 }}>{item.type}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{item.price}</td>
              <td style={{ padding: '12px 16px', color: parseInt(item.temp) > 34 ? '#F59E0B' : '#16A34A', fontSize: 13, fontWeight: 600 }}>{item.temp}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text)', fontSize: 13 }}>{item.onHand}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text-muted)', fontSize: 13 }}>{item.grind ? 'Yes' : '-'}</td>
              <td style={{ padding: '12px 16px' }}><span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: `${SC[item.status]}20`, color: SC[item.status] }}>{item.status}</span></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
